<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="webTerminalName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="webTerminalName"></wbo-main-search-column>
        <wbo-column field="webTerminalType"></wbo-column>
        <wbo-column field="terminalName"></wbo-column>
        <wbo-column field="webTerminalId"></wbo-column>
        <wbo-column field="floatedIn"></wbo-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
